<div class="new-request">
    <div class="new-request__serials">
        <label for="serials" class="lx-label">Serial Numbers (CSV)</label>
        <textarea type="text" [(ngModel)]="serialNumbers" name="serials" id="serials"></textarea>
    </div>

    <div class="new-request__name">
        <label for="name" class="lx-label">Name</label>
        <input type="text" [(ngModel)]="name" autocomplete="off" name="name" id="name">
    </div>

    <div class="new-request__description">
        <label for="description" class="lx-label">Description</label>
        <input type="text" [(ngModel)]="description" autocomplete="off" name="description" id="description">
    </div>

    <div class="new-request__new-request">
        <button id="newRequest" class="lx-btn lx-btn-primary" (click)="submitRequest()">Create New
            Request</button>
    </div>
</div>